import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { Col, Flex, Row, Typography, Grid, theme, Button, Drawer } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as FavoritesStar } from "./../../../assets/icons/favorite-star.svg";
import { useTranslation } from "@inscore/shared";
import "../../../components/favoritesComponent/favoritesComponent.css";
import "./favoritesHeader.css";
import Search from "./../../search/Search.js";
const { Title } = Typography;
const { useBreakpoint } = Grid;
const FavoritesHeader = ({ children, onFavoriteToggle }) => {
  const [open, setOpen] = useState(false);
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const { t } = useTranslation();
  useEffect(() => {
    document.body.style.overflowY = open ? "hidden" : "auto";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, [open]);
  const showDrawer = () => {
    setOpen(true);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "content-gray-box favorites-header",
      style: { paddingBottom: 0 },
      children: [
        /* @__PURE__ */ jsxs(
          Row,
          {
            justify: "space-between",
            align: "middle",
            style: { marginBottom: screens.md ? 24 : 12 },
            children: [
              /* @__PURE__ */ jsx(Col, { sm: 12, md: 12, children: /* @__PURE__ */ jsx(
                Flex,
                {
                  justify: screens.md ? "start" : "space-between",
                  align: "center",
                  children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, style: { flexShrink: 0 }, children: [
                    /* @__PURE__ */ jsx(
                      Flex,
                      {
                        align: "center",
                        justify: "center",
                        className: "favorites-component-wrapper",
                        style: {
                          display: "flex",
                          cursor: "default",
                          width: screens.md ? 40 : 32,
                          height: screens.md ? 40 : 32,
                          borderRadius: "50%",
                          flexShrink: 0,
                          backgroundColor: token.colorBgContainer,
                          border: "1.5px solid " + token.colorBgActive
                        },
                        children: /* @__PURE__ */ jsx(FavoritesStar, { className: "favorite-star selected" })
                      }
                    ),
                    /* @__PURE__ */ jsx(Title, { level: 4, style: { margin: 0 }, children: t("my_favorites") })
                  ] })
                }
              ) }),
              /* @__PURE__ */ jsx(
                Col,
                {
                  sm: 12,
                  md: 12,
                  style: {
                    textAlign: screens.md ? "right" : "left"
                  },
                  children: /* @__PURE__ */ jsx(
                    Flex,
                    {
                      align: "center",
                      justify: screens.md ? "end" : "start",
                      gap: 20,
                      children: /* @__PURE__ */ jsx(
                        Button,
                        {
                          type: "primary",
                          icon: /* @__PURE__ */ jsx(PlusOutlined, { style: { fontSize: 16 } }),
                          onClick: showDrawer,
                          style: {
                            backgroundColor: token.colorLinkActive,
                            height: 40,
                            fontWeight: 600,
                            fontSize: screens.md ? token.fontSize : token.fontSizeXS,
                            padding: "0 12px"
                          },
                          children: t("new_favorites")
                        }
                      )
                    }
                  )
                }
              )
            ]
          }
        ),
        children,
        /* @__PURE__ */ jsx(
          Drawer,
          {
            closable: true,
            destroyOnHidden: true,
            title: t("add_new_favorites"),
            placement: "right",
            open,
            onClose: () => setOpen(false),
            zIndex: 1060,
            width: 480,
            className: "add-favorites-drawer",
            children: /* @__PURE__ */ jsx(Search, { isInDrawer: true, onFavoriteToggle })
          }
        )
      ]
    }
  );
};
var stdin_default = memo(FavoritesHeader);
export {
  stdin_default as default
};
